import { Suspense } from 'react';
import { Navbar } from './components';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import { LazyHeader as Header, LazyAbout as About, LazyWork as Work, LazySystems as Systems, LazySkills as Skills, LazyTestimonial as Testimonial, LazyFooter as Footer, LazyFloatingBubbles as FloatingBubbles } from './utils/lazyLoad';
import './App.scss';

// Loading component
const LoadingSpinner = () => (
  <div className="app__flex" style={{ minHeight: '100vh' }}>
    <div className="app__loading">Loading...</div>
  </div>
);

export const App = () => {
  return (
    <div className='app'>
      <Suspense fallback={null}>
        <FloatingBubbles />
      </Suspense>
      <ScrollToTop />
      <Navbar />
      <Suspense fallback={<LoadingSpinner />}>
        <Header />
      </Suspense>
      <Suspense fallback={<LoadingSpinner />}>
        <About />
      </Suspense>
      <Suspense fallback={<LoadingSpinner />}>
        <Work />
      </Suspense>
      <Suspense fallback={<LoadingSpinner />}>
        <Systems />
      </Suspense>
      <Suspense fallback={<LoadingSpinner />}>
        <Skills />
      </Suspense>
      <Suspense fallback={<LoadingSpinner />}>
        <Testimonial />
      </Suspense>
      <Suspense fallback={<LoadingSpinner />}>
        <Footer />
      </Suspense>
    </div>
  );
}

export default App;